import * as ActionTypes from './types.action';

export const search = (params, jjToken, fulfillmentDetails) => ({
  type: ActionTypes.GET_SEARCH_RESULTS_REQUESTED,
  params,
  jjToken,
  fulfillmentDetails,
});

export const moreSearch = (params, token, fulfillmentDetails) => ({
  type: ActionTypes.GET_MORE_SEARCH_RESULTS_REQUESTED,
  params,
  token,
  fulfillmentDetails,
});

export const getSearchSuggestions = keyword => ({
  type: ActionTypes.GET_SEARCH_SUGGESTIONS_REQUESTED,
  keyword,
});

export const resetSearchSuggestions = () => ({
  type: ActionTypes.GET_SEARCH_SUGGESTIONS_RESET,
});

export const getSearchFromServerSide = (searchResults, correctedQuery) => ({
  type: ActionTypes.GET_SEARCH_RESULTS_SUCCESS,
  searchResults,
  correctedQuery,
});

export const relatedProductClicked = ({
  searchId,
  parentSearchId,
  strategy,
  itemId,
  searchPosition,
}) => ({
  type: ActionTypes.RELATED_PRODUCT_CLICKED,
  searchId,
  parentSearchId,
  strategy,
  itemId,
  searchPosition,
});

export const searchInsteadClicked = ({searchId, query, correctedQuery}) => ({
  type: ActionTypes.SEARCH_INSTEAD_CLICKED,
  searchId,
  query,
  correctedQuery,
});

export const getSearchPageFromServerSide = page => ({
  type: ActionTypes.GET_SEARCH_RESULTS_PAGE_SUCCESS,
  page,
});

export const getFacetsFromServerSide = aggression => ({
  type: ActionTypes.GET_SEARCH_AGGREGATE_SUCCESS,
  aggression,
});

export const getSearchCategoryDescription = ({category, brand}) => ({
  type: ActionTypes.GET_SEARCH_CATEGORY_DESCRIPTION_REQUESTED,
  category,
  brand,
});
